import { Box, Button, Flex, List, ListItem } from '@chakra-ui/react';
import { camelCase } from 'lodash';
import { CheckFill } from '~/components/icons';

import { StepperFormNavViewport } from './StepperFormNav.types';

export const StepperFormNavDesktop: React.FC<StepperFormNavViewport> = ({
  isLoading,
  isLinear,
  onClick,
  steps,
  stepsState,
  ...boxProps
}) => {
  return (
    <Box
      as="nav"
      minWidth={175}
      maxWidth={200}
      marginRight={7}
      paddingRight={7}
      borderRightColor="primary.100"
      borderRightStyle="solid"
      borderRightWidth={1}
      {...boxProps}
    >
      <List>
        {steps.map(({ title }, index) => {
          const { isActive, isDisabled, isRequired, isCompleted, hasError } =
            stepsState[index];
          const isLinearCompleted = isLinear && isCompleted;
          return (
            <ListItem key={`${camelCase(title)}-${index}`} paddingY={3}>
              <Button
                _active={{
                  color: 'primary.500',
                  fontWeight: 500,
                  _before: {
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    width: '48px',
                    height: '3px',
                    marginTop: 1,
                    borderRadius: '8px',
                    backgroundColor: 'secondary.500',
                    content: '""',
                  },
                }}
                _disabled={{ color: 'primary.200' }}
                _hover={{ textDecoration: 'none' }}
                position="relative"
                isDisabled={isLoading || isDisabled}
                display="block"
                isActive={isActive}
                onClick={() => onClick(index)}
                variant="link"
                color={!isLinear && hasError ? 'error.500' : 'primary.300'}
                fontWeight={isLinearCompleted ? 500 : 400}
              >
                <Flex alignItems="center">
                  {title}
                  {(isRequired || (!isLinear && hasError)) && '*'}
                  {isLinearCompleted && (
                    <CheckFill marginLeft={1} color="primary.300" />
                  )}
                </Flex>
              </Button>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};
